<div #GlobalSettingsWrapper *ngIf="!mobile" #elementRef>
  <div id="globalSettingsHeader">{{ 'Global Settings' | translate }}</div>
  <div id="globalSettingsBody">
    <div id="globalSettingsForm" (ngSubmit)="onSubmit()" class="styleFields">
      <mat-progress-bar mode="indeterminate" *ngIf="showGlobalSettingsProgress"></mat-progress-bar>
      <ul>
        <li>
          <mat-label>{{ 'Font Family' | translate }}</mat-label>
          <mat-select *ngIf="this.builderService.globalSettings" (selectionChange)="styleChange('font-family', $event, 'font', 'style')" value="{{ this.builderService.globalSettings['font-family'] }}">
            <mat-option value="{{ font.family }}" *ngFor="let font of fonts">
              {{ font.family }}
            </mat-option>
          </mat-select>
        </li>
        <li>
          <mat-label>{{ 'Arabic Font' | translate }}</mat-label>
          <mat-select *ngIf="this.builderService.globalSettings" (selectionChange)="styleChange('font-family-rtl', $event, 'font', 'style')" value="{{ this.builderService.globalSettings['font-family-rtl'] }}">
            <mat-option value="{{ font.family }}" *ngFor="let font of fonts">
              {{ font.family }}
            </mat-option>
          </mat-select>
        </li>
        <li>
          <mat-label>{{ 'Font Size' | translate }}</mat-label>
          <mat-slider showTickMarks discrete *ngIf="this.builderService.globalSettings" max="70" min="5" step="1" thumbLabel="true">
            <input matSliderThumb ngModel="{{ this.builderService.globalSettings['font-size']?.slice(0, -2) }}" (change)="styleChange('font-size', $event, 'slider', 'style')" />
          </mat-slider>
        </li>
        <!-- Side menu: items + design for the whole app (replaces the old menu list) -->
        <li class="globalSideMenu">
          <h4 class="globalSideMenuTitle">{{ 'Side Menu' | translate }}</h4>
          <block-sidemenu [embedded]="true"></block-sidemenu>
        </li>
        <!-- <li>
            <mat-label>{{ 'Font Weight' | translate }}</mat-label>
            <mat-select (selectionChange)="styleChange('font-weight', blockId, $event, 'select','style')"
              value="{{getBlockFields(blockId).style['font-weight']}}">
              <mat-option value="normal">
                {{ 'Normal' | translate }}
              </mat-option>
              <mat-option value="bold">
                {{ 'Bold' | translate }}
              </mat-option>
            </mat-select>
          </li> -->
        <!-- <li>
            <mat-label>{{ 'Font Variant' | translate }}</mat-label>
            <mat-select (selectionChange)="styleChange('font-variant', $event, 'select','style')"
            value="{{this.builderService.globalSettings['font-variant']}}">
              <mat-option value="{{variants}}" *ngFor="let variants of selectedFont.variants">
                {{variants}}
              </mat-option>
            </mat-select>
          </li> -->
      </ul>
    </div>
  </div>
</div>
